import React, { useState, Fragment } from 'react';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Icofont from 'react-icofont';
import { STRIPE_ID } from '../../constants/Payment';

const MEMBER_TYPE = {
    REGULAR: "R",
    PREMIUM: "P",
}

const PREMIUM_TYPE = {
    BASIC: "Basic",
    EXTRA1: "Extra $200 x 1",
    EXTRA2: "Extra $200 x 3",
    EXTRA3: "Extra $200 x 5",
    EXTRA4: "Extra $200 x 10"
}

const PREMIUM_ITEMS = {
    [PREMIUM_TYPE.BASIC]: { paypal: PREMIUM_TYPE.BASIC, stripe: 2, amount: 400 },
    [PREMIUM_TYPE.EXTRA1]: { paypal: PREMIUM_TYPE.EXTRA1, stripe: 3, amount: 600 },
    [PREMIUM_TYPE.EXTRA2]: { paypal: PREMIUM_TYPE.EXTRA2, stripe: 5, amount: 1000 },
    [PREMIUM_TYPE.EXTRA3]: { paypal: PREMIUM_TYPE.EXTRA3, stripe: 7, amount: 1400 },
    [PREMIUM_TYPE.EXTRA4]: { paypal: PREMIUM_TYPE.EXTRA4, stripe: 12, amount: 2400 }
}

const STRIPE_REGULAR_PLAN = "plan_GL71QcLsN7MOV3";      //plan_GL71QcLsN7MOV3 | plan_GL6WGOvOfXfpvB
const STRIPE_PREMIUM_PLAN = "plan_GL8lzmd22BdiBD";      //plan_GL8lzmd22BdiBD
const REGULAR_PRICE = 200;

const Monthly = props => {

    const [selectedType, setSelectedType] = useState(undefined);
    const [selectedPlan, setSelectedPlan] = useState(PREMIUM_TYPE.BASIC);

    const onChange = (value) => {
        setSelectedType(value);
    }
    const regularPrice = () => {
        return REGULAR_PRICE;
    }
    const premiumPrice = () => {
        return PREMIUM_ITEMS[selectedPlan].amount;
    }
    const renderPaymentValue = () => {
        switch (selectedType) {
            case MEMBER_TYPE.REGULAR:
                return `$${regularPrice()} HKD`;
            case MEMBER_TYPE.PREMIUM:
                return `$${premiumPrice()} HKD`;
            default:
                return "請先選擇贊助類別";
        }
    }
    const stripeOnClick = (planId, quantity) => {
        let stripe = window.Stripe(STRIPE_ID);       //pk_live_PsMmbdMS6qsptv9VeTHO083h00IZdYdFgr
        stripe.redirectToCheckout({
            items: [{ plan: planId, quantity: quantity }],

            // Do not rely on the redirect to the successUrl for fulfilling
            // purchases, customers may not always reach the success_url after
            // a successful payment.
            // Instead use one of the strategies described in
            // https://stripe.com/docs/payments/checkout/fulfillment
            successUrl: 'https://news.hkgolden.com/success',
            cancelUrl: 'https://news.hkgolden.com/canceled',
            locale: 'en'
        })
            .then(function (result) {
                if (result.error) {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer.
                    var displayError = document.getElementById('error-message');
                    displayError.textContent = result.error.message;
                }
            });
    }

    const stripeRegularBtn = () => {
        return (
            <button className="button payment-button" onClick={() => stripeOnClick(STRIPE_REGULAR_PLAN, 1)}>
                <Icofont className="payment-icon" icon="icofont-stripe" />
                <div className="mask" />
            </button>
        )
    }

    const striplePremiumBtn = () => {
        return (
            <button className="button payment-button" onClick={() => stripeOnClick(STRIPE_PREMIUM_PLAN, PREMIUM_ITEMS[selectedPlan].stripe)}>
                <Icofont className="payment-icon" icon="icofont-stripe" />
                <div className="mask" />
            </button>
        )
    }

    const paypalRegularBtn = () => {
        return (
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value="56JWLYM22RB36" />
                <h3 className="payment-header">贊助選項：</h3>
                <p className="payment-amount">只適用於尊貴月費會員</p>
                <h3 className="payment-header">支付金額：</h3>
                <p className="payment-amount">{renderPaymentValue()}</p>
                <h3 className="payment-header">請選擇付款方式：</h3>
                <button type="submit" className="button payment-button">
                    <Icofont className="payment-icon" icon="icofont-paypal" />
                    <div className="mask" />
                </button>
            </form>
        )
    }

    const paypalPremiumBtn = () => {
        return (
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value="YRWJMRDXJ5F72" />
                <input type="hidden" name="on0" value="" />
                <h3 className="payment-header">贊助選項：</h3>
                <select className="payment-select" onChange={planOnChange} name="os0">
                    <option value={PREMIUM_TYPE.BASIC}>基本 $400.00 HKD (每月)</option>
                    <option value={PREMIUM_TYPE.EXTRA1}>基本 $400 + 額外 $200 x 1 = $600 HKD (每月)</option>
                    <option value={PREMIUM_TYPE.EXTRA2}>基本 $400 + 額外 $200 x 3 = $1,000 HKD (每月)</option>
                    <option value={PREMIUM_TYPE.EXTRA3}>基本 $400 + 額外 $200 x 5 = $1,400 HKD (每月)</option>
                    <option value={PREMIUM_TYPE.EXTRA4}>基本 $400 + 額外 $200 x 10 = $2,400 HKD (每月)</option>
                </select>
                <input type="hidden" name="currency_code" value="HKD" />
                <h3 className="payment-header">支付金額：</h3>
                <p className="payment-amount">{renderPaymentValue()}</p>
                <h3 className="payment-header">請選擇付款方式：</h3>
                <button type="submit" className="button payment-button">
                    <Icofont className="payment-icon" icon="icofont-paypal" />
                    <div className="mask" />
                </button>
                <img alt="" border="0" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1" />
            </form>
        )
    }


    const planOnChange = (event) => {
        setSelectedPlan(event.target.value);
    }

    return (
        <Fragment>
            <div className="instruction-container">
                <div className="payment-instruction">
                    <ol>
                        <li>先選擇贊助會員類別</li>
                        <li>如選擇尊貴月費會員，可按意願支付更多月費作為對我們額外的支持</li>
                        <li>確認支付金額</li>
                        <li>按 Stripe / PayPal 網頁指示輸入個人資料，並完成付款程序</li>
                        <li>我們將透過電郵確認你的付款支持</li>
                    </ol>
                </div>
            </div>
            <h3 className="payment-header">選擇贊助類別：</h3>

            <RadioGroup onChange={onChange} className="member-select">
                <RadioButton value={MEMBER_TYPE.REGULAR} iconSize={25} iconInnerSize={15} rootColor={"#3b3b3b"} pointColor={"#346599"}>
                    普通月費會員
                    </RadioButton>
                <RadioButton value={MEMBER_TYPE.PREMIUM} iconSize={25} iconInnerSize={15} rootColor={"#3b3b3b"} pointColor={"#346599"}>
                    尊貴月費會員
                    </RadioButton>
            </RadioGroup>
            <div className="payment">
                {selectedType ? (selectedType === MEMBER_TYPE.PREMIUM ? paypalPremiumBtn() : paypalRegularBtn()) : ""}
                {selectedType ? (selectedType === MEMBER_TYPE.PREMIUM ? striplePremiumBtn() : stripeRegularBtn()) : ""}

            </div>
            <div id="error-message"></div>
        </Fragment>
    );
}
export default Monthly;